const openDocument = (source) => {
    const pdf = window.PDFViewerApplication
    if (pdf) {
        return pdf.open.call(pdf, source)
    }
}

export default openDocument